export default "__VITE_ASSET__Cg19uy5R__"